// extracted by mini-css-extract-plugin
export default {"on_hover":"styles_on_hover__aWpl+","drop_down":"styles_drop_down__xRTBB","text":"styles_text__Ohu5o"};